(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var sd = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  if (sd && !reduce) root.classList.add('anv-sd');

  var main = document.getElementById('MainContent');
  var isHome = !!(main && /^index/.test(main.getAttribute('data-template') || ''));

  var bar = document.createElement('div');
  bar.className = 'anv-progress'; bar.setAttribute('aria-hidden', 'true');
  var fill = document.createElement('span'); bar.appendChild(fill); document.body.appendChild(bar);

  /* Parallax samo na naslovni (hero) */
  if (isHome && !reduce) {
    var hero = main.querySelector('.shopify-section');
    if (hero) hero.querySelectorAll('img, video').forEach(function (m) { m.classList.add('anv-parallax'); });
  }

  var ticking = false;
  function onScroll() {
    var y = window.scrollY;
    root.classList.toggle('anv-scrolled', y > 40);
    if (!sd) {
      var h = root.scrollHeight - window.innerHeight;
      fill.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, Math.max(0, y / h)) : 0) + ')';
    }
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  if (fine && !reduce) {
    var ring = document.createElement('div'); ring.className = 'anv-cursor';
    var dot = document.createElement('div'); dot.className = 'anv-cursor-dot';
    var aura = document.createElement('div'); aura.className = 'anv-aura';
    document.body.appendChild(aura); document.body.appendChild(ring); document.body.appendChild(dot);
    var tx = 0, ty = 0, rx = 0, ry = 0, ax = 0, ay = 0, shown = false, running = false;
    var loop = function () {
      rx += (tx - rx) * 0.22; ry += (ty - ry) * 0.22; ax += (tx - ax) * 0.08; ay += (ty - ay) * 0.08;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      aura.style.transform = 'translate3d(' + ax.toFixed(1) + 'px,' + ay.toFixed(1) + 'px,0)';
      if (Math.abs(tx - rx) + Math.abs(ty - ry) + Math.abs(tx - ax) + Math.abs(ty - ay) > 0.6) requestAnimationFrame(loop); else running = false;
    };
    var lastBtn = null;
    window.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      dot.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
      if (!shown) { shown = true; rx = ax = tx; ry = ay = ty; ring.classList.add('anv-on'); dot.classList.add('anv-on'); aura.classList.add('anv-on'); }
      if (!running) { running = true; requestAnimationFrame(loop); }
      var el = e.target && e.target.closest ? e.target : null;
      if (!el) return;
      ring.classList.toggle('anv-hot', !!el.closest('a, button, summary, [role="button"], product-card, .product-card, input, select, label'));
      var card = el.closest('product-card, .product-card');
      if (card) { var r = card.getBoundingClientRect(); card.style.setProperty('--mx', (e.clientX - r.left) + 'px'); card.style.setProperty('--my', (e.clientY - r.top) + 'px'); }
      var btn = el.closest('.button, button[type="submit"]');
      if (lastBtn && lastBtn !== btn) { lastBtn.style.setProperty('--bx', '0px'); lastBtn.style.setProperty('--by', '0px'); }
      if (btn) { var b = btn.getBoundingClientRect(); btn.style.setProperty('--bx', ((e.clientX - b.left - b.width / 2) * 0.16).toFixed(1) + 'px'); btn.style.setProperty('--by', ((e.clientY - b.top - b.height / 2) * 0.24).toFixed(1) + 'px'); }
      lastBtn = btn;
    }, { passive: true });
    document.addEventListener('mouseleave', function () { ring.classList.remove('anv-on'); dot.classList.remove('anv-on'); aura.classList.remove('anv-on'); shown = false; });
  }

  if (reduce || !main) { root.classList.remove('anv-js'); return; }

  /* Reveal – ENAKA logika na vseh straneh: vse sekcije (razen prve), noga, kartice, članki */
  var targets = [];
  var seen = new Set();
  function add(el) { if (!el || seen.has(el)) return; seen.add(el); el.classList.add('anv-reveal'); targets.push(el); }

  var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section')).filter(function (s) { return !s.parentElement.closest('.shopify-section'); });
  sections.forEach(function (s, i) { if (i > 0) add(s); });
  var foot = document.querySelector('footer');
  if (foot) add(foot);

  /* Kartice izdelkov, članki in bloki znotraj sekcij: postopno */
  var cardSel = 'product-card, .product-card, article-card, .article-card, .blog-post-card, .collection-card, .resource-card';
  main.querySelectorAll(cardSel).forEach(function (c, i) {
    c.style.setProperty('--anv-delay', ((i % 4) * 110) + 'ms');
    if (!sd) add(c);
  });
  if (sd) main.querySelectorAll(cardSel).forEach(function (c) { if (!c.closest('.anv-reveal')) add(c); });

  /* Naslovi po besedah (vse strani) */
  main.querySelectorAll('h1, h2').forEach(function (h) {
    if (h.querySelector('*') || !h.textContent.trim() || h.closest('product-card, .product-card, form')) return;
    var words = h.textContent.trim().split(/\s+/);
    h.setAttribute('aria-label', h.textContent.trim());
    h.textContent = '';
    words.forEach(function (w, i) {
      var o = document.createElement('span'); o.className = 'anv-word'; o.setAttribute('aria-hidden', 'true');
      var n = document.createElement('span'); n.textContent = w; n.style.setProperty('--i', i);
      o.appendChild(n); h.appendChild(o);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
    h.classList.add('anv-split');
    if (!sd) targets.push(h);
  });

  if (sd || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('anv-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  targets.forEach(function (t) { io.observe(t); });
  setTimeout(function () { targets.forEach(function (t) { if (t.getBoundingClientRect().top < window.innerHeight) t.classList.add('anv-in'); }); }, 3500);
})();
